import { render } from "./NewAcceptTermSuccess.vue?vue&type=template&id=e75b6cd6&scoped=true"
import script from "./NewAcceptTermSuccess.vue?vue&type=script&lang=js"
export * from "./NewAcceptTermSuccess.vue?vue&type=script&lang=js"

import "./NewAcceptTermSuccess.vue?vue&type=style&index=0&id=e75b6cd6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e75b6cd6"]])

export default __exports__